import styled, { css } from 'styled-components';
import MainButton from '~/src/components/form-components/main-button/main-button';
import { RegionField } from '~/src/components/common-components/region-field/region-field';
import { rem } from '~/src/helpers/rem-converter.helper';
import { mediaQuery } from '~/src/styles/mixins';
import { FONTS } from '~/src/styles/style-helpers/font-helper';
import { BORDER_RADIUS } from '~/src/styles/tokens/border-radius';
import { MAX_567, MAX_767, MIN_320 } from '~/src/styles/tokens/break-points';
import { COLORS } from '~/src/styles/tokens/colors';

export const GeolocationModalContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: ${rem(420)};
    height: fit-content;
    border-radius: ${BORDER_RADIUS.biggest20};
    box-sizing: border-box;

    ${mediaQuery({ maxWidth: MAX_567 }, css`
        width: ${rem(320)};
    `)};

    ${mediaQuery({ maxWidth: MIN_320 }, css`
        width: ${rem(270)};
    `)};
`;

export const GeolocationModalContentHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
`;

export const GeolocationModalContentTitle = styled.h4`
    ${FONTS.compact.medium.size20};
    color: ${COLORS.textLightPrimary};

    ${mediaQuery({ maxWidth: MAX_767 }, css`
        width: 90%;
    `)};
`;

export const IconContainer = styled.div`
    width: ${rem(32)};
    height: ${rem(32)};
    border-radius: ${BORDER_RADIUS.medium6};
    background-color: ${COLORS.controlsLightTertiaryActive};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;

export const SvgWrapper = styled.div`
    width: ${rem(24)};
    height: ${rem(24)};
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const GeolocationModalContentSubTitle = styled.p`
    ${FONTS.compact.regular.size14};
    color: ${COLORS.textLightSecondary};
    margin-bottom: ${rem(12)};
`;

export const RegionFieldWrapper = styled(RegionField)`
    margin-bottom: ${rem(24)};
`;

export const MainButtonWrapper = styled(MainButton)`
    width: 100%;
`;